// hooks
import useOrchidDriveDataInView from "components/Dashboard/DoctorDashboard/hooks/useOrchidDriveDataInView";
import { usePatientChartsDrive } from "contexts/orchid-drive";
// types
import type { TreeWidgetDataContainerProps } from "../..";
// components
import TreeWidgetUI from "../tree-widget-ui";

const TreeWidgetPatientCharts = ({
  patient,
  folderPaths,
  children,
}: TreeWidgetDataContainerProps) => {
  const {
    entries,
    createDirectoryPatientChart,
    // uploadFilePatientChart,
    // deleteEntry,
    batchEntryOps,
  } = usePatientChartsDrive({
    patientCharts: patient
      ? [
          {
            patientUserId: patient.orchid_user_id,
            directoryId:
              folderPaths[folderPaths.length - 1]?.directoryId || null,
            // TODO: add paging
            pages: [0],
          },
        ]
      : [],
  });

  const dataInView = useOrchidDriveDataInView(entries[0].pages[0]);

  return (
    <>
      <TreeWidgetUI
        onCreateDir={(name, parentDirectoryId) =>
          createDirectoryPatientChart({
            name,
            parentDirectoryId,
            patientUserId: patient?.orchid_user_id || "",
          })
        }
        dataInView={dataInView}
        batchEntryOps={batchEntryOps}
      />
      {children}
    </>
  );
};

export default TreeWidgetPatientCharts;
